import { EnvironmentProviders, Provider } from '@angular/core'

import { ChatUpdatesListener } from '@ti/shared/chat/services/chat-updates.listener'

import {
  ASSISTANT_CONFIG,
  AssistantConfig,
  DEFAULT_ASSISTANT_CONFIG,
} from './contracts/assistant.config'

/**
 * Declares how the assistant feature behaves in the host
 * application, without bringing in any of the chat infrastructure.
 */
export const provideAssistantConfig = (config: Partial<AssistantConfig>): Provider[] => {
  return [
    {
      provide: ASSISTANT_CONFIG,
      useValue: { ...DEFAULT_ASSISTANT_CONFIG, ...config },
    },
  ]
}

/**
 * Everything the standalone assistant page needs in an application
 * that has no chat feature of its own — the TSP and TI admin apps.
 */
export const provideAssistant = (
  config: Partial<AssistantConfig> = {},
): (Provider | EnvironmentProviders)[] => {
  config = { ...config, showHeader: false }
  return [...provideAssistantConfig(config), ChatUpdatesListener]
}
